import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import { withTranslation } from 'react-i18next';
import { getRelatedTyresApi } from '../../../../api/endpoints';
import routeTyrePage from '../../../../pages/TyrePage/route';
import {
  Section,
  SectionTitle,
  Grid,
  TyreCard,
  ImageContainer,
  TyreImage,
  ImagePlaceholder,
  BrandBadge,
  TyreName,
  TyreSpecs,
  SpecLine,
  Description,
  LoadingContainer,
} from './RelatedTyres.style';

class RelatedTyres extends Component {
  static propTypes = {
    ean: PropTypes.string.isRequired,
    dimension: PropTypes.string,
    productLine: PropTypes.string,
    history: PropTypes.object.isRequired,
    compact: PropTypes.bool,
  };

  state = {
    loading: true,
    tyres: [],
  };

  componentDidMount() {
    this.fetchRelatedTyres();
  }

  fetchRelatedTyres = async () => {
    const {ean, dimension, i18n} = this.props;
    const language = i18n?.language || 'en';

    try {
      this.setState({loading: true});
      const tyres = await getRelatedTyresApi(ean, dimension, language);
      this.setState({tyres, loading: false});
    } catch (error) {
      console.error('Error fetching related tyres:', error);
      this.setState({tyres: [], loading: false});
    }
  };

  handleTyreClick = (ean) => {
    this.props.history.push(routeTyrePage(ean));
    window.scrollTo({top: 0, behavior: 'smooth'});
  };

  render() {
    const {loading, tyres} = this.state;
    const {compact, t} = this.props;

    if (loading) {
      return (
        <Section compact={compact}>
          <SectionTitle compact={compact}>{t('relatedProducts')}</SectionTitle>
          <LoadingContainer>
            <i
              className="mdi mdi-loading mdi-spin"
              style={{fontSize: compact ? '20px' : '24px', marginRight: '8px'}}
            />
            {compact ? `${t('loading')}...` : t('loadingRelatedProducts')}
          </LoadingContainer>
        </Section>
      );
    }

    if (tyres.length === 0) {
      return null;
    }

    // Limit to 4 products (2 rows x 2 columns) in compact mode
    const displayTyres = compact ? tyres.slice(0, 4) : tyres;

    return (
      <Section compact={compact}>
        <SectionTitle compact={compact}>{t('relatedProducts')}</SectionTitle>
        <Grid compact={compact}>
          {displayTyres.map((tyre) => (
            <TyreCard
              key={tyre.ean}
              onClick={() => this.handleTyreClick(tyre.ean)}
              compact={compact}
            >
              {!compact && (
                <ImageContainer>
                  {tyre.mainImage?.fullpath ? (
                    <TyreImage
                      src={tyre.mainImage.fullpath}
                      alt={tyre.productName}
                    />
                  ) : (
                    <ImagePlaceholder>
                      <i className="mdi mdi-tire" />
                    </ImagePlaceholder>
                  )}
                </ImageContainer>
              )}
              {tyre.singleBrandKey?.name && (
                <BrandBadge>{tyre.singleBrandKey.name}</BrandBadge>
              )}
              <TyreName compact={compact}>
                {tyre.productName || tyre.ean}
              </TyreName>
              <TyreSpecs>
                {tyre.dimensionMetric && (
                  <SpecLine compact={compact}>
                    <i className="mdi mdi-ruler" />
                    {tyre.dimensionMetric}
                  </SpecLine>
                )}
                {tyre.season && (
                  <SpecLine compact={compact}>
                    <i className="mdi mdi-weather-sunny" />
                    {tyre.season}
                  </SpecLine>
                )}
                {tyre.loadSpeedIndex && (
                  <SpecLine compact={compact}>
                    <i className="mdi mdi-speedometer" />
                    {tyre.loadSpeedIndex}
                  </SpecLine>
                )}
              </TyreSpecs>
              {!compact && tyre.marketingText && (
                <Description>{tyre.marketingText}</Description>
              )}
            </TyreCard>
          ))}
        </Grid>
      </Section>
    );
  }
}

export default withRouter(withTranslation()(RelatedTyres));
